'use strict';

var StepSposGridInteractionsDirective = function StepSposGridInteractionsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-spos-grid-interactions.html')
  };
};
StepSposGridInteractionsDirective.$inject = [];
module.exports = StepSposGridInteractionsDirective;